
import layers from './../layer';
import WKT from "ol/format/WKT";
var Sqrl = require('squirrelly')
const $ = window.$;

const suggest_administrativeunit_URL= contextPath+"/rest/administrativeunit/suggest/"
const bigSmallMapBreakpoint =  768;

//var source   = document.getElementById("parcel-template").innerHTML;
//var template = simpletemplate("parceltemplate");
var compiled = Sqrl.Compile(document.getElementById("parceltemplate").innerHTML)

function handleFetchResponse(fetchPromise) {
	//var parcelInfoElement = $("#parcelinfo");
	//var parcelInfoElementDynamic = $("div.dynamic",parcelInfoElement);
	fetchPromise.then(function(response) {
		if (response.status === 200) {
			return response.json();
		} else {
			$(".selectinfo").hide()
            $(".map-inner .selectinfo").attr("data-status", "closed");
            $(".map-inner .selectinfo").attr("data-id", "");
		}
	})
	.then(function(parcelInfoJson){
	//parcelInfoElementDynamic.empty();
		if (parcelInfoJson) {
            
            var defaultProperties = {
                size:{value : ""},
                location:{value : ""},
                availability:{value : ""},
                parceltype:{value : ""},
                airport:{value : ""},
                freeway:{value : ""},
                name:{value : ""}
            };
            parcelInfoJson.properties= Object.assign({},defaultProperties,parcelInfoJson.properties);
            
            parcelInfoJson.extent = [ parcelInfoJson.extent.minX,
					parcelInfoJson.extent.minY,
					parcelInfoJson.extent.maxX,
					parcelInfoJson.extent.maxY ].join();
            
            var html    = compiled(parcelInfoJson, Sqrl)
            $(".selectinfo .info_parcel").html(html)
             if($( window ).width() < bigSmallMapBreakpoint) {
                 var popupStatus = $(".map-inner .selectinfo").attr("data-status") || "open";
                 var dataID = $(".map-inner .selectinfo").attr("data-id");
                 if(popupStatus!=="folded" || dataID != parcelInfoJson.id) {
                     $(".map-inner .selectinfo").css("left", "");
                     $("#togglemap .selectinfo .card-body").show()
                     $("#togglemap .selectinfo").show();
                     $(".map-inner .selectinfo").attr("data-status", "open");
                     $(".map-inner .selectinfo").attr("data-id", parcelInfoJson.id+"");
                     $('#map-tab').tab('show')
                 }
             }else {
                 $("#map .selectinfo").show();
             }
            /*
			parcelInfoJson.order.forEach(function(propertyWrapper){
				var cont = $("<div/>").addClass("row").appendTo(parcelInfoElementDynamic)
				$("<label/>").html(parcelInfoJson.properties[propertyWrapper].label+": ").addClass("font-weight-bold col").appendTo(cont);
				$("<span/>").addClass("col").html(parcelInfoJson.properties[propertyWrapper].value).appendTo(cont);
				
			});
	
			var googleEarthLink = $("a.googleearth",parcelInfoElement)
			if (parcelInfoJson.showGoogleEarth) {
				googleEarthLink.show()
			} else {
				googleEarthLink.hide()
			}
			var editLink = $("a.edit",parcelInfoElement)
			if (parcelInfoJson.showEdit) {
				editLink.show()
			} else {
				editLink.hide()
			}
            */
	/*
			var extent = [ parcelInfoJson.extent.minX,
					parcelInfoJson.extent.minY,
					parcelInfoJson.extent.maxX,
					parcelInfoJson.extent.maxY ].join()
                    */
			//console.log(" extent: " + parcelInfoJson.extent)
			var feature = new WKT().readFeature(parcelInfoJson.geom,{dataProjection:"EPSG:25832", featureProjection:"EPSG:3857"})
			layers.selectLayer.getSource().addFeature(feature);
			//$("#zoomtoButton").data("extent", extent);
			//$("a.expose",parcelInfoElement).attr("href", $("a.expose",parcelInfoElement).data("href")+parcelInfoJson.id);
			
			//parcelInfoElement.show()
		} else {
			//parcelInfoElement.hide()
            $(".selectinfo").hide();
            $(".map-inner .selectinfo").attr("data-status", "closed");
            $(".map-inner .selectinfo").attr("data-id", "");
		}
	});
}
function fetchInfoByID(id) {
	layers.selectLayer.getSource().clear();
	handleFetchResponse(fetch(contextPath + '/rest/commercialspace/parcel/info/'+lang+'/' + id))
			
}
function fetchInfo(x, y) {
	layers.selectLayer.getSource().clear();
	var params = "x=" + x + "&y=" + y
	handleFetchResponse(fetch(contextPath + '/rest/commercialspace/parcel/info/'+lang+'?' + params))
			

}

$("#zoomtoButton").on("click", function() {
	console.log($(this).data('extent'))
	zoomTo($(this).data('extent'))
})

function suggestAdministrativeUnit(query, cb) {
	fetch(suggest_administrativeunit_URL + query).then(
			function(response) {
				return response.json();
			}).then(function(json) {
		cb(json)
	})
}

$("#city_select").autoComplete({
    resolver: 'custom',
   minLength:1,
    events: {
        search: function (qry, callback) {
            // let's do a custom ajax call
            $.ajax(suggest_administrativeunit_URL+qry,null)
                .done(function (res) {
                    var result = res.map(entry => {
                        var debug = {
                            name:entry.name,
                            id:entry.ags
                        }
                        return debug;
                    })
                    
                callback(result)
            });
        },
        typed: function(test) {
            return test
        }
    }
})



				
        


function postData(url = "", data = {}) {
	  // Default options are marked with *
	    return fetch(url, {
	        method: "POST", // *GET, POST, PUT, DELETE, etc.
	        mode: "cors", // no-cors, cors, *same-origin
	        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
	        credentials: "same-origin", // include, *same-origin, omit
	        headers: {
	            "Content-Type": "application/json",
	            // "Content-Type": "application/x-www-form-urlencoded",
	        },
	        redirect: "follow", // manual, *follow, error
	        referrer: "no-referrer", // no-referrer, *client
	        body: JSON.stringify(data), // body data type must match "Content-Type" header
	    })
	    .then(response => response.json()); // parses JSON response into native Javascript objects 
	}

export default {
    postData : postData,
    suggestAdministrativeUnit : suggestAdministrativeUnit,
    fetchInfo : fetchInfo,
    fetchInfoByID : fetchInfoByID
}

